module.exports = __webpack_public_path__ + "static/img/background.80a471d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background.jpeg
// module id = mTjc
// module chunks = 3